const items = (that) => [
    {
        enabled: true,
        key: "all-automations",
        group: that?.$t("automation.automations") || "Automations",
        label: that?.$t("automation.allAutomations") || "Automation",
        icon: {
            type: "material-icons",
            name: "settings_suggest",
        },
    },
    {
        enabled: true,
        key: "scheduled-automations",
        group: that?.$t("automation.automations") || "Automations",
        label: that?.$t("automation.scheduledAutomations") || "Scheduled Automation",
        icon: {
            type: "material-icons",
            name: "history",
        },
    },
    {
        enabled: true,
        key: "event-based-automations",
        group: that?.$t("automation.automations") || "Automations",
        label: that?.$t("automation.eventBasedAutomations") || "Event Based Automations",
        icon: {
            type: "material-icons",
            name: "event",
        },
    },
    {
        enabled: true,
        key: "button-automations",
        group: that?.$t("automation.automations") || "Automations",
        label: that?.$t("automation.buttonAutomations") || "Button Automations",
        icon: {
            type: "material-icons",
            name: "ads_click",
        },
    },
    {
        enabled: true,
        key: "webhook-automations",
        group: that?.$t("automation.automations") || "Automations",
        label: that?.$t("automation.webhookAutomations") || "Webhook Automations",
        icon: {
            type: "material-icons",
            name: "webhook",
        },
    },
    {
        enabled: true,
        key: "automation-insights",
        group: that?.$t("automation.analytics") || "Analytics",
        label: that?.$t("automation.insights") || "Insights",
        icon: {
            type: "material-icons",
            name: "insights",
        },
    },
    {
        enabled: true,
        key: "automation-sandbox",
        group: that?.$t("automation.automations") || "Automations",
        label: that?.$t("automation.trash") || "Trash Bin",
        icon: {
            type: "material-icons",
            name: "delete_outline",
        },
    }
];

export default items;
